import { render, staticRenderFns } from "./ProzessFileUpload.vue?vue&type=template&id=b6b384a8"
import script from "./ProzessFileUpload.vue?vue&type=script&lang=js"
export * from "./ProzessFileUpload.vue?vue&type=script&lang=js"
import style0 from "./ProzessFileUpload.vue?vue&type=style&index=0&id=b6b384a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports